// Bolero PDP add-ons (site-upgrade #5) — adds checked buy-box add-ons in the SAME action as
// the main "Add to cart" submit.
//
// Integrates with the theme's existing ATC contract instead of forking it. The theme's
// <product-form> custom element (js/common/product/product-form.js, bundled in theme.js)
// attaches its own "submit" listener directly on the inner <form action="/cart/add">
// element (the event target) inside connectedCallback. This script adds a SEPARATE listener
// on `document` with useCapture=true for the same "submit" event.
//
// Per the DOM event dispatch model, a capturing listener on an ancestor (document) always
// runs during the capture phase, which happens strictly BEFORE the target phase (where
// <product-form>'s own listener lives, attached to the <form> itself) — regardless of script
// load order or listener registration order. So this listener is guaranteed first look at
// every /cart/add form submit on the page.
//
// If no add-ons are checked for that form, this listener does nothing and lets the event
// continue exactly as normal (native single-item ATC, unchanged). Only when at least one
// add-on IS checked does it take over: event.preventDefault() + stopImmediatePropagation()
// stop the event before it ever reaches <product-form>'s own listener (so there is no
// double-add), and this script performs the combined add itself via a single
// POST {Shopify.routes.root}cart/add.js call with a JSON `items` array (main variant +
// checked add-ons) — the same endpoint, same bundled-sections / loading / variant:add /
// cart:change event contract onSubmit_fn uses (see theme.js), just with more than one line.
//
// No changes to theme.js. No new cart-add path for the common (no add-ons checked) case.

(function () {
  function checkedAddonItems(container) {
    var boxes = container.querySelectorAll('input[type="checkbox"][data-addon-variant-id]:checked');
    return Array.prototype.map.call(boxes, function (box) {
      return { id: parseInt(box.getAttribute('data-addon-variant-id'), 10), quantity: 1 };
    });
  }

  function bundledSections() {
    var sections = [];
    document.documentElement.dispatchEvent(
      new CustomEvent('cart:prepare-bundled-sections', { bubbles: true, detail: { sections: sections } })
    );
    return sections;
  }

  document.addEventListener(
    'submit',
    function (event) {
      var form = event.target;
      if (!(form instanceof HTMLFormElement)) return;
      if (!form.action || form.action.indexOf('/cart/add') === -1) return;

      // NOTE: form.id is NOT safe to use here. Shopify's own product form
      // (js/common/product/product-form.js, bundled in theme.js) intentionally
      // relies on the HTML forms named-item quirk where a same-named
      // <input name="id"> shadows the form element's own `id` IDL attribute —
      // `form.id` resolves to that INPUT element, not the form's HTML id
      // attribute string. That shadowing broke this file's original
      // `data-form-id` lookup: string-concatenating an element coerces to
      // "[object HTMLInputElement]", which never matches the liquid-rendered
      // `data-form-id`, so addonsBlock was always null and add-ons were
      // silently never captured. Use getAttribute('id') to get the real
      // string id, same way the theme's own code separately grabs the
      // variant id via form.querySelector('input[name="id"]') a few lines
      // below rather than form.id.
      var formHtmlId = form.getAttribute('id');
      if (!formHtmlId) return;

      var addonsBlock = document.querySelector('.bolero-pdp-addons[data-form-id="' + formHtmlId + '"]');
      if (!addonsBlock) return; // no add-ons block wired to this form — native ATC handles it

      var addonItems = checkedAddonItems(addonsBlock);
      if (addonItems.length === 0) return; // nothing checked — native single-item ATC is correct

      var idInput = form.querySelector('input[name="id"]');
      var mainVariantId = idInput ? parseInt(idInput.value, 10) : null;
      if (!mainVariantId) return; // no valid variant selected — let the native handler show its own error

      var qtyInput = form.querySelector('input[name="quantity"]');
      var mainQuantity = qtyInput && qtyInput.value ? parseInt(qtyInput.value, 10) : 1;

      // From here on we own this submit — stop it before <product-form>'s own listener
      // (attached to this same <form> target) ever sees it.
      event.preventDefault();
      event.stopImmediatePropagation();

      var items = [{ id: mainVariantId, quantity: mainQuantity }].concat(addonItems);

      var submitButtons = Array.prototype.filter.call(form.elements, function (el) {
        return el.type === 'submit';
      });
      submitButtons.forEach(function (button) {
        button.setAttribute('aria-busy', 'true');
      });
      document.documentElement.dispatchEvent(new CustomEvent('theme:loading:start', { bubbles: true }));

      var sections = bundledSections();

      fetch(window.Shopify.routes.root + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify({ items: items, sections: sections })
      })
        .then(function (response) {
          return response.json().then(function (json) {
            return { ok: response.ok, json: json };
          });
        })
        .then(function (result) {
          submitButtons.forEach(function (button) {
            button.removeAttribute('aria-busy');
          });
          document.documentElement.dispatchEvent(new CustomEvent('theme:loading:end', { bubbles: true }));

          if (!result.ok) {
            form.dispatchEvent(
              new CustomEvent('cart:error', { bubbles: true, detail: { error: result.json && result.json.description } })
            );
            document.dispatchEvent(new CustomEvent('cart:refresh'));
            return;
          }

          if (
            window.themeVariables &&
            window.themeVariables.settings &&
            (window.themeVariables.settings.cartType === 'page' || window.themeVariables.settings.pageType === 'cart')
          ) {
            window.location.href = window.Shopify.routes.root + 'cart';
            return;
          }

          fetch(window.Shopify.routes.root + 'cart.js')
            .then(function (response) {
              return response.json();
            })
            .then(function (cartContent) {
              cartContent.sections = result.json.sections;
              form.dispatchEvent(
                new CustomEvent('variant:add', {
                  bubbles: true,
                  detail: {
                    items: result.json.items || [result.json],
                    cart: cartContent
                  }
                })
              );
              document.documentElement.dispatchEvent(
                new CustomEvent('cart:change', {
                  bubbles: true,
                  detail: { baseEvent: 'variant:add', cart: cartContent }
                })
              );
            });
        })
        .catch(function () {
          submitButtons.forEach(function (button) {
            button.removeAttribute('aria-busy');
          });
          document.documentElement.dispatchEvent(new CustomEvent('theme:loading:end', { bubbles: true }));
        });
    },
    true
  );
})();
